module.exports = __webpack_public_path__ + "img/648x595.5df25de3.png";